/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable unicorn/consistent-function-scoping */

/* eslint-disable unicorn/prefer-logical-operator-over-ternary */
/* eslint-disable unicorn/explicit-length-check */
/* eslint-disable unicorn/no-useless-promise-resolve-reject */

/* eslint-disable no-prototype-builtins */
/* eslint-disable unicorn/no-array-for-each */

/* eslint-disable unicorn/prevent-abbreviations */

// https://stackoverflow.com/a/66848536/16340209
import { Str } from '../Str'
import type { ClientHttpMethod, ModelMetaData, ModelPaginatedResponse, ModelSortOptions, ModelSortOrder, RequestOptions } from '.'
import { Client } from './Client'
import { ModelQueryBuilder } from './ModelQueryBuilder'

export class Model extends Client {
  protected $endpoint = ''

  protected $primaryKey: any = 'id'

  protected $fillable: any[] = []

  protected $page: number | null = null

  protected $limit: number | null = null

  protected $sort: ModelSortOptions<any> = {}

  public $meta?: ModelMetaData = {
    current_page: 0,
    from: 0,
    last_page: 0,
    next_page_url: '',
    per_page: 0,
    prev_page_url: '',
    to: 0,
    total: 0,
  }

  protected $includes: string[] = []

  protected $metaIncludes: string[] = []

  protected $filters: object = {}

  protected $rejects: object = {}

  public hydrate(attributes: Record<string, any> | Partial<this> = {}): this {
    // Run the mutators, modifying any of the model's attributes from the response.
    Object.entries(attributes).forEach(([key, attribute]) => {
      this.setAttribute(key, attribute)
    })

    return this
  }

  /**
   * Sets the attribute value by running its mutator if available.
   */

  public setAttribute(attribute: string, value: any): void {
    const setterMethod = `set${Str.studly(attribute)}Attribute`
    const isMutateable = Object.getPrototypeOf(this).hasOwnProperty(setterMethod)

    try {
      ;(this as Record<string, any>)[`${attribute}`] = isMutateable ? (this as Record<string, any>)[`${setterMethod}`](value) : value
    } catch (error) {
      Model.debug(isMutateable ? `[ERROR] MUTATOR ${setterMethod}` : `[ERROR] ATTRIBUTE ${attribute}`, value)
      Model.debug(error)
    }
  }

  public exists(): boolean {
    const isNullOrUndefined = (value: any) => value === null || value === undefined

    return !isNullOrUndefined((this as any)[this.$primaryKey])
  }

  public first(): Promise<this> {
    return this.limit(1)
      .all()
      .then(
        (models: this[]) => {
          if (models === undefined || !Array.isArray(models)) {
            return Promise.reject(models)
          }

          Object.assign(this, models[0])

          return Promise.resolve(models[0])
        },

        (error: object) => Promise.reject(error),
      )
  }

  /**
   * Fetch results form the API in chunks of the specified size.
   * This is useful for handling heavy operations in smaller steps or going through all of the paginated data of an endpoint.
   */

  public async chunk(callback: (records: this[]) => Promise<void>, queryParameters?: object, chunkSize = 100): Promise<void> {
    const firstChunk = await this.limit(chunkSize).all(queryParameters)

    const results = firstChunk
    if (results) {
      await callback(results)
    }

    const lastPage = firstChunk[0]?.$meta?.last_page || 1

    if (firstChunk[0]?.$meta?.current_page === undefined) {
      return
    }

    let nextPage = firstChunk[0].$meta.current_page + 1
    while (nextPage <= lastPage) {
      const chunk = await this.limit(chunkSize).page(nextPage).all(queryParameters)

      if (chunk[0]?.$meta?.current_page === undefined) {
        break
      }

      nextPage = chunk[0].$meta.current_page + 1

      if (chunk) {
        await callback(results)
      }
    }
  }

  /**
   * Performs a list call on a model resource endpoint.
   * Any attributes provided are attached to the API call as query parameters.
   */

  public all(attributes?: object): Promise<this[]> {
    const url = this.$endpoint

    return this.request('GET', url, attributes)
  }

  /**
   * Performs a read call on a model resource endpoint.
   * Any attributes provided are attached to the API call as query parameters.
   */

  public find(id: string | number, attributes?: object): Promise<this | null> {
    const url = `${this.$endpoint}/${id}`

    return this.request('GET', url, attributes)
  }

  public create(attributes?: object): Promise<this> {
    const url = this.$endpoint

    attributes = this.getPayload(attributes)

    return this.request('POST', url, attributes)
  }

  public put(attributes?: object): Promise<this> {
    const url = `${this.$endpoint}/${this.resolvePrimaryKey()}`

    return this.request('PUT', url, this.getPayload(attributes))
  }

  public update(attributes?: object): Promise<this> {
    const url = `${this.$endpoint}/${this.resolvePrimaryKey()}`

    return this.request('PATCH', url, this.getPayload(attributes))
  }

  public delete(attributes?: object): Promise<null> {
    const url = `${this.$endpoint}/${this.resolvePrimaryKey()}`

    return this.request('DELETE', url, attributes)
  }

  public resolvePrimaryKey(): string {
    return (this as any)[this.$primaryKey]
  }

  public getPayload(attributes?: object): object {
    if (attributes === undefined) {
      attributes = { ...{}, ...(this as Record<string, any>) } as this

      const keys = Object.keys(attributes)

      keys.forEach((property) => {
        if (!this.isFillable(property)) {
          delete (attributes as any)[`${property}`]
        }
      })
    }
    return attributes
  }

  public getQueryBuilderUrl(url: string): string {
    const queryBuilder = new ModelQueryBuilder(url)

    if (this.$includes.length) {
      queryBuilder.push({
        with: this.$includes,
      })
    }

    if (this.$metaIncludes.length) {
      queryBuilder.push({
        meta: this.$metaIncludes,
      })
    }

    if (Object.keys(this.$filters).length) {
      queryBuilder.push({
        filters: this.$filters,
      })
    }

    if (Object.keys(this.$rejects).length) {
      queryBuilder.push({
        rejects: this.$rejects,
      })
    }

    if (this.$page !== null) {
      queryBuilder.push({
        page: this.$page,
      })
    }

    if (this.$limit !== null) {
      queryBuilder.push({
        limit: this.$limit,
      })
    }

    const sortOptions = this.getSortOptions()
    if (sortOptions.key) {
      queryBuilder.push({
        sort: sortOptions.order === 'DESC' ? `!${sortOptions.key}` : sortOptions.key,
      })
    }

    return queryBuilder.url
  }

  public request(method: ClientHttpMethod, url: string, payload: any = {}, options: RequestOptions = {}): Promise<any> {
    const queryBuilderUrl = this.getQueryBuilderUrl(url)

    // console.log(`[NETWORK] ${method.toUpperCase()} ${url} ${JSON.stringify(payload)}`);
    return this.call(method, queryBuilderUrl, payload, {}, options).then(
      (response: object) => {
        const modelResponse = this.responseToModel(response)

        return Promise.resolve(modelResponse)
      },
      (error: any) => {
        if (error.response !== undefined && error.response.status === 401) {
          // store.dispatch('userDeauthenticated');
        }

        return Promise.reject(error)
      },
    )
  }

  public include(includes: any | any[]): this {
    if (typeof includes === 'string') {
      includes = [includes]
    }

    this.$includes = includes
    return this
  }

  public filter(
    filters: any,

    value?: any,
  ): this {
    if (typeof filters === 'string') {
      const key = filters
      filters = {}
      ;(filters as any)[`${key}`] = value || null
    }

    this.$filters = { ...this.$filters, ...filters }

    return this
  }

  public setFilters(filters: any): this {
    this.$filters = { ...filters }

    return this
  }

  public reject(
    rejects: any,

    value?: any,
  ): this {
    if (typeof rejects === 'string') {
      const key = rejects
      rejects = {}
      ;(rejects as any)[`${key}`] = value || null
    }

    this.$rejects = { ...this.$rejects, ...rejects }

    return this
  }

  public removeFilter(key: any): this {
    if ((this.$filters as any)[`${key}`]) {
      delete (this.$filters as any)[`${key}`]
    }

    return this
  }

  public removeReject(key: any): this {
    if ((this.$rejects as any)[`${key}`]) {
      delete (this.$rejects as any)[`${key}`]
    }

    return this
  }

  public page(page: number): this {
    if (!page) {
      return this
    }

    this.$page = page

    return this
  }

  public limit(limit: number): this {
    if (!limit) {
      return this
    }

    this.$limit = limit

    return this
  }

  public isFillable(key: any): boolean {
    return this.$fillable.includes(key)
  }

  public sort(key: any, order: ModelSortOrder = 'ASC'): this {
    if (!key) {
      this.$sort = {}

      return this
    }

    this.$sort = { key, order }

    return this
  }

  public getSortOptions(): ModelSortOptions<any> {
    return this.$sort
  }

  public dataToModel(data: ModelPaginatedResponse | Record<string, any>, rows?: this[] | boolean): this | this[] {
    // console.log('[dataToModel]', `Is Paginated: ${rows && Array.isArray(rows) ? 'YES' : 'NO'}`, rows);
    if (rows && Array.isArray(rows)) {
      const meta: ModelMetaData = {
        from: data.from || 1,
        to: data.to || 1,
        next_page_url: data.next_page_url || '',
        prev_page_url: data.prev_page_url || '',
        per_page: data.per_page || rows.length,
        current_page: data.current_page || 1,
        last_page: data.last_page || 1,
        total: data.total || 1,
      }

      rows.forEach((row, index: any) => {
        // eslint-disable-next-line security/detect-object-injection
        rows[index] = this.rowToModel(row)
        // eslint-disable-next-line security/detect-object-injection
        rows[index].$meta = {
          ...meta,
          ...(data.meta ? data.meta : {}),
        }
      })

      return rows
    }

    return this.rowToModel(data)
  }

  public responseToModel(response: Record<string, any>): any {
    const isPaginatedResponse =
      response.data !== undefined && Array.isArray(response.data) && response.next_page_url !== undefined && response.prev_page_url !== undefined
    const data = response

    const rows: this[] | boolean = isPaginatedResponse ? response.data : false

    return this.dataToModel(data, rows)
  }

  public rowToModel(row: Record<string, any>): this {
    let model: this = new (this.constructor as any)(this.$options)

    // Populate the initial model with the response.
    Object.keys(row).forEach((key) => {
      ;(model as Record<string, any>)[`${key}`] = row[`${key}`]
    })

    model = model.hydrate(row)

    return model
  }

  public clone(): this {
    return Object.assign(Object.create(Object.getPrototypeOf(this)), this)
  }

  public includeMeta(metaIncludes: any | any[]): this {
    if (typeof metaIncludes === 'string') {
      metaIncludes = [metaIncludes]
    }

    this.$metaIncludes = metaIncludes

    return this
  }

  // protected hasOne(relationshipModel: typeof Model, relationshipName: string) {
  //   return new HasOne(this, relationshipModel, relationshipName);
  // }

  public get endpoint(): string {
    return this.$endpoint
  }

  public set endpoint(endpoint: string) {
    this.$endpoint = endpoint
  }

  public get queryUrl(): string {
    return this.getQueryBuilderUrl(this.$endpoint)
  }
}
